// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RITT","largestCol":"styles_largestCol__FlPf4","smallestCol":"styles_smallestCol__1r7fo"};